// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.initialization-container, .initialization-error-container {
  position: relative;
  background-color: black;
  height: 100%;
  width: 100%;
}

.initialization-container .label, .initialization-error-container .label {
  position: absolute;
  top: 50%;
  left: 50%;
  text-transform: uppercase;
  transform: translate(-50%, -50%);
  margin: 0;
  font-size: 28px;
  font-weight: bold;
}

.initialization-container .label, .image-container-alert {
  color: white;
}

.initialization-error-container .label {
  color: red;
}

.shooting-screen-container {
  height: 100%;
  background-color: black;
  position: relative;
}

.initialization-container button,
.initialization-error-container button,
.shooting-screen-container button {
  z-index: 999;
}

.btn-cancel-init {
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
}

.btn-cancel-init button {
  margin: 10px;
}

.image-container-alert {
  align-items: center;
  display: flex;
  height: 100%;
  background: black;
  justify-content: center;
  z-index: 10000000000000000;
  width: 100%;
}

.image-container-alert .label {
  font-size: 28px;
  font-weight: bold;
  text-transform: uppercase;
}

/*.shooting-screen-container .btn-cancel,
.initialization-container .btn-cancel,
.initialization-error-container .btn-cancel {
    top: 10px;
    right: 10px;
}
.shooting-screen-container .btn-enroll {
   top: 10px;
    left: 10px; 
}*/
.shade {
  display: flex;
  max-height: 100vh;
  max-width: 100vw;
  height: 100vh;
  width: 100vw;
  box-sizing: border-box;
}

.cam_left__collumn, .cam_right__collumn {
  background: #f8f8fa;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 80px;
  padding: 10px;
  align-items: center;
}

.image-container {
  width: 100%;
  box-sizing: border-box;
  background-color: black;
}

.btn-cancel {
  width: 55px;
  height: 55px;
  background: #e4e8eb;
  border-radius: 7px;
}

.btn-confirm {
  width: 55px;
  height: 55px;
  background: #448aff;
  border-radius: 7px;
}

.image-container__frame {
  position: fixed;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 85%;
  height: 100vh;
  width: 100vw;
}

.light_icon {
  color: #44494e;
}

.light_icon__active {
  color: #448aff;
}

.rotate {
  transform: rotate(180deg);
  transition: 0.75s;
}

.derotate {
  transform: rotate(0deg);
  transition: 0.75s;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/dev/qrreader/qrreader.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AACJ;;AACA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,gCAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;AAEJ;;AAAA;EACI,YAAA;AAGJ;;AADA;EACI,UAAA;AAIJ;;AAFA;EACI,YAAA;EACA,uBAAA;EACA,kBAAA;AAKJ;;AAHA;;;EAGI,YAAA;AAMJ;;AAJA;EACI,uBAAA;EAAA,kBAAA;EACA,wBAAA;EAAA,mBAAA;AAOJ;;AALA;EACI,YAAA;AAQJ;;AANA;EACI,mBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,0BAAA;EACA,WAAA;AASJ;;AAPA;EACI,eAAA;EACA,iBAAA;EACA,yBAAA;AAUJ;;AARA;;;;;;;;;EAAA;AAUA;EACI,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;AAWJ;;AATA;EACI,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAYJ;;AAVA;EACI,WAAA;EACA,sBAAA;EACA,uBAAA;AAaJ;;AAXA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAcJ;;AAZA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAeJ;;AAbA;EACI,eAAA;EACA,4BAAA;EACA,2BAAA;EACA,oBAAA;EACA,aAAA;EACA,YAAA;AAgBJ;;AAdA;EACI,cAAA;AAiBJ;;AAfA;EACI,cAAA;AAkBJ;;AAhBA;EACI,yBAAA;EACA,iBAAA;AAmBJ;;AAjBA;EACI,uBAAA;EACA,iBAAA;AAoBJ","sourcesContent":[".initialization-container, .initialization-error-container {\n    position: relative;\n    background-color: black;\n    height: 100%;\n    width: 100%;\n}\n.initialization-container .label, .initialization-error-container .label {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    text-transform: uppercase;\n    transform: translate(-50%, -50%);\n    margin: 0;\n    font-size: 28px;\n    font-weight: bold;\n}\n.initialization-container .label, .image-container-alert {\n    color: white;\n}\n.initialization-error-container .label {\n    color: red;\n}\n.shooting-screen-container {\n    height: 100%;\n    background-color:black;\n    position: relative;\n}\n.initialization-container button,\n.initialization-error-container button,\n.shooting-screen-container button {\n    z-index: 999;\n}\n.btn-cancel-init {\n    width: fit-content;\n    height: fit-content;\n}\n.btn-cancel-init button {\n    margin: 10px;\n}\n.image-container-alert {\n    align-items: center;\n    display: flex;\n    height: 100%;\n    background: black;\n    justify-content: center;\n    z-index: 10000000000000000;\n    width: 100%;\n}\n.image-container-alert .label {\n    font-size: 28px;\n    font-weight: bold;\n    text-transform: uppercase;\n}\n/*.shooting-screen-container .btn-cancel,\n.initialization-container .btn-cancel,\n.initialization-error-container .btn-cancel {\n    top: 10px;\n    right: 10px;\n}\n.shooting-screen-container .btn-enroll {\n   top: 10px;\n    left: 10px; \n}*/\n.shade {\n    display: flex;\n    max-height: 100vh;\n    max-width: 100vw;\n    height: 100vh;\n    width: 100vw;\n    box-sizing: border-box;\n}\n.cam_left__collumn, .cam_right__collumn {\n    background: #f8f8fa;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 80px;\n    padding: 10px;\n    align-items: center;\n}\n.image-container {\n    width: 100%;\n    box-sizing: border-box;\n    background-color: black;\n}\n.btn-cancel {\n    width: 55px;\n    height: 55px;\n    background: #e4e8eb;\n    border-radius: 7px;\n}\n.btn-confirm {\n    width: 55px;\n    height: 55px;\n    background: #448aff;\n    border-radius: 7px;\n}\n.image-container__frame {\n    position: fixed;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 85%;\n    height: 100vh;\n    width: 100vw;\n}\n.light_icon {\n    color: #44494e;\n}\n.light_icon__active {\n    color: #448aff;\n}\n.rotate {\n    transform: rotate(180deg);\n    transition: 0.75s;\n}\n.derotate {\n    transform: rotate(0deg);\n    transition: 0.75s;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
